import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import {useTranslation} from "react-i18next";
import {Close} from "@material-ui/icons";
import {COOKIE_KEYS, getCookieValue, setCookie} from "../../utils/CookieUtils";
import {getCookiesConsentVisible, getCookiesPolicyLink, getDataPrivacyLink} from '../../api/SystemSettingsEndpoints';
import {RR_STATUS} from "../../constants/RRConstants";
import {useSnackbar} from "notistack";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        snackbar: {
            "& .MuiSnackbarContent-action": {
                padding: 0,
                flex: 1,
                justifyContent: "space-between",
                "& button": {
                    marginRight: 5
                }
            },

        },
        closeButton: {
            position: "fixed",
            right: 0,
            top: 0
        }
    }),
);

const CookiePolicyBanner: React.FC = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();

    const [cookiePolicy, setCookiePolicy] = React.useState(getCookieValue(COOKIE_KEYS.SPOT_COOKIE_POLICY));
    const [bannerVisible, setBannerVisible] = React.useState<boolean>(false);


    React.useEffect(() => {

        getCookiesConsentVisible().then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("core.server-error"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {
                setBannerVisible(response);
            }
        });


    }, [t, enqueueSnackbar]);

    const handleClose = () => {
        setCookiePolicy(true);
    };

    const handleCookiePolicy = () => {
        getCookiesPolicyLink().then(({data}) => {
            const win = window.open(data.response, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    };

    const handleDataPrivacyLink = () => {
        getDataPrivacyLink().then(({data}) => {
            const win = window.open(data.response, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    };


    React.useEffect(() => {
        setCookie(COOKIE_KEYS.SPOT_COOKIE_POLICY, true);

    }, []);

    if (cookiePolicy || !bannerVisible) {
        return null;
    }


    const render = (
        <React.Fragment>
            <Snackbar
                anchorOrigin={{vertical: "top", horizontal: "center"}}
                open
                message={t("cookies.content")}
                action={
                    <>
                        <div>
                            <Button variant="contained" color="primary" size="small" onClick={handleCookiePolicy}>
                                {t("cookies.policy")}
                            </Button>
                            <Button variant="contained" color="primary" size="small" onClick={handleDataPrivacyLink}>
                                {t("cookies.policy-info")}
                            </Button>
                        </div>
                        <Button id="cookie-banner-close" color="inherit" size="small" startIcon={<Close/>}
                                onClick={handleClose}>
                            {t("core.close")}
                        </Button>
                    </>
                }
                className={classes.snackbar}
            />


        </React.Fragment>
    );

    return render;
};

export default CookiePolicyBanner;
